import { useState, useMemo } from 'react'

export const useChartState = () => {
  const [charts, setCharts] = useState({})
  return useMemo(() => ({ charts, updateCharts: setCharts }), [charts])
}
